module.exports = "/assets/loading.gif?D3JAjMy";